<template>
  <a
    v-if="href"
    class="h-button"
    :disabled="disabled"
    :class="classes"
    :href="url"
  >
    <div class="h-button-content">
      <h-loader v-if="loading" class="h-mr-10"/>
      <slot/>
    </div>
  </a>
  <router-link
    v-else-if="to"
    class="h-button"
    :class="classes"
    :to="url"
  >
    <div class="h-button-content">
      <h-loader v-if="loading" class="h-mr-10"/>
      <slot/>
    </div>
  </router-link>
  <button
    v-else
    class="h-button"
    :disabled="disabled"
    :class="classes"
    @click="$emit('click')"
  >
    <div class="h-button-content">
      <h-loader v-if="loading" class="h-mr-10"/>
      <slot/>
    </div>
  </button>
</template>
<script>
import HLoader from '@/components/base/HLoader.vue'

export default {
  name: 'HButton',
  components: { HLoader },
  props: {
    type: {
      type: String,
      default: 'primary'
    },
    block: {
      type: Boolean,
      default: false
    },
    shape: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: 'middle'
    },
    href: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    to: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    url() {
      if (this.href) {
        const queryString = window?.location?.search || ''
        return `${this.href}${queryString}`
      }
      else if (this.to)
        return { path: this.to, query: this.$route.query}
      return ''
    },
    classes() {
      return {
        'h-button--block': this.block,
        'h-button--round': this.shape === 'round',
        'h-button--large': this.size === 'large',
        'h-button--middle': this.size === 'middle',
        'h-button--small': this.size === 'small',
        [`h-button-type--${this.type}`]: true,
        'active': this.active === true,
        'h-button--loading': this.loading
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.h-button {
  display: inline-flex;
  padding: 8px;
  line-height: 20px;
  cursor: pointer;
  transition: all 0.3s;
  border: none;
  outline: none;
  border-radius: 8px;
  min-width: 60px;
  justify-content: center;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  &-content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
  &:hover {
    background-color: lighten(#FADB14, 10%)
  }
  &--block {
    display: block;
    width: 100%;
  }
  &--round {
    border-radius: 50px;
  }
  &--small {
    padding: 4px;
    line-height: 14px;
  }
  &--middle {
    padding: 8px;
    line-height: 22px;
  }
  &--large {
    padding: 16px;
    line-height: 24px;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }
  &-type {
    &--ghost {
      background-color: transparent;
      outline: 1px solid #d9d9d9;
      &:hover {
        background-color: unset;
        outline: 1px solid;
      }
      &.active {
        background-color: unset;
        outline: 1px solid;
      }
    }
    &--primary {
      background: #FADB14;
      color: #262626;

      &:hover {
        background-color: lighten(#FADB14, 10%);
      }
      &.active {
        background-color: #FADB14;

        &:disabled {
          background-color: lighten(#FADB14, 30%) !important;
        }
      }
    }
    &--secondary {
      background: white;
      border: 1px solid #D9D9D9;
      color: #595959;

      &:hover {
        background-color: lighten(#FADB14, 10%);
      }
      &.active {
        background-color: #FADB14;

        &:disabled {
          background-color: lighten(#FADB14, 30%) !important;
        }
      }
    }
    &--text {
      background-color: transparent;
      outline: unset;
      color: #FADB14;
      &:hover {
        background-color: transparent;
        outline: unset;
        color: lighten(#FADB14, 10%);
      }
    }
  }
  &:disabled {
    pointer-events: none;
    border: 1px solid #d9d9d9 !important;
    background-color: #f5f5f5 !important;
    color: hsla(0, 0%, 6%, 0.6) !important;
  }
  &--loading {
    pointer-events: none;
    background-color: lighten(#FADB14, 25%) !important;
  }
}

</style>
